module.exports = __webpack_public_path__ + "img/00019.7d66ece1.webp";